<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm02"></a><a id="page_3"></a>Tell Me What to Eat If I Have Celiac Disease</h1>
<p class="sub"><em>Nutrition You Can Live With</em></p>
<p class="authortitle">By Kimberly A. Tessmer, RD, LD<br/>Foreword by Elaine Magee</p>
<p class="images1"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?78c3d264